<template>
	<div class="foot">
		<ul class="friendly">
			<li><span>友情链接：</span> <a href="http://www.nppa.gov.cn/">国家新闻出版总署</a></li>
			<li><a href="http://www.ncac.gov.cn/">国家版权局</a></li>
			<li><a href="http://www.samr.gov.cn/">国家市场监督管理总局</a></li>
			<li><a href="https://www.cnipa.gov.cn/">国家知识产权局</a></li>
			<li><a href="http://www.ccopyright.com.cn/">中国版权保护中心</a></li>
			<li><a href="https://www.chinaxwcb.com/">中国新闻出版广电网</a></li>
			<li><a href="http://www.csccn.org.cn/">中国版权协会</a></li>
			<li><a href="http://www.pac.org.cn/">中国出版协会</a></li>
			<li><a href="http://www.mcsc.com.cn/">中国音乐著作权协会</a></li>
			<li><a href="https://www.cavca.org/">中国音像著作权集体管理协会</a></li>
			<li><a href="http://www.prccopyright.org.cn/">中国文字著作权协会</a></li>
			<li><a href="http://www.cfca-c.org/">中国电影著作权协会</a></li>
			<li><a href="http://amr.gd.gov.cn/">广东省市场监督管理局（知识产权局）</a></li>
			<li><a href="http://amr.sz.gov.cn/">深圳市市场监督管理局（深圳市知识产权局）</a></li>
			<li><a href="http://www.gd-copyright.cn/gdcrsp/">广东省版权网</a></li>
			<li><a href="https://www.gippc.com.cn/">广东省知识产权保护中心</a></li>
			<li><a href="http://www.gzbanquan.com/">广州市版权保护中心</a></li>
			<li><a href="http://www.gdippa.com/">广东知识产权保护协会</a></li>
			<li><a href="http://www.cagz.org/">广州市版权协会</a></li>
			<li><a href="http://www.scs.org.cn/">深圳版权协会</a></li>
			<li><a href="http://www.fcps.org.cn/">佛山版权协会</a></li>
		</ul>
		<div class="about">
			<div>
				<!-- <img width="150px" src="../assets/logo-white.png" alt=""> -->
				<div>
					<span style="margin-right: 10px;">版权所有：广东省版权保护联合会</span>
					<span style="margin-right: 10px;">电话：020-37667333 ，37638239</span>
					<span style="margin-right: 10px;">传真：020-37638192</span>
					<span style="margin-right: 10px;">地址：广州市海珠区新港东路1066号国茶荟3-B01</span>
					<p><a style="color: #fff" href="http://beian.miit.gov.cn/">备案编号：粤ICP备2020084870号-1</a></p>
					<p>技术支持：广州诚彩科技有限公司</p>
				</div>
				<!-- <div>
					<img width="80px" src="../assets/1595300177.jpg" alt="">
					<p>联合会微信公众号</p>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {};
		},
		mounted() {},
		methods: {},
	};
</script>
<style scoped>
	.foot {
		border-top: 1px solid #ddd;
		margin-top: 20px;
		color: gray;
	}

	.friendly {
		display: flex;
		flex-wrap: wrap;
		padding: 0 10%;
	}

	.friendly li {
		margin-right: 30px;
		margin-top: 10px;
		font-size: 13px;
	}

	.friendly li span {
		color: #016fb8;
		font-weight: bold;
		font-size: 14px;
	}

	.friendly li a {
		color: gray;
	}

	.friendly li:hover {
		/* color: #016fb8; */
		cursor: pointer;
	}

	.about {
		margin-top: 20px;
		padding: 10px 20px 0;
		font-size: 13px;
		background: #016fb8;
		box-sizing: border-box;
		color: #fff;
	}

	.about>div {
		display: flex;
		justify-content: center;
		align-items: center;
		text-align: center;
	}
	
	.about>div > div:nth-child(2) {
		margin: 0 20px;
		text-align: left;
	}
	
	.about > div > div p {
		margin-bottom: 10px;
	}

	.about > div > div p img {
		width: 24px;
		vertical-align: middle;
		margin-right: 5px;
	}

	.about > div > div p span {
		vertical-align: middle;
	}
</style>
